import { render, staticRenderFns } from "./PaymentDetail.vue?vue&type=template&id=b308e9fc&scoped=true"
import script from "./PaymentDetail.vue?vue&type=script&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&lang=js"
import style0 from "./PaymentDetail.vue?vue&type=style&index=0&id=b308e9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b308e9fc",
  null
  
)

export default component.exports